import React from "react";

import Dialog from '../Dialog';
import Button from "../Button";

import IntlMessage from '../../LocaleEngine';
import LocaleAsString from "../../LocaleEngine/LocaleAsString";

import { getLocale, setLocale, getSystemSettings } from "../../utils/SettingsRetriever";

import './index.scss';

export default class LanguageSelector extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            displayModal: false,
            selectedLanguage: getLocale() || "en"
        }
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClick, false);
    }
    
    componentWillUnmount() {
        document.removeEventListener('click', this.handleClick, false);
    }

    handleClick = (e) => {
        if (this.node){
          if ( !this.node.contains(e.target) ){
            this.setState({ displayModal: false })
          }
        }
    }

    renderLanguagesList = () => {
        if(getSystemSettings().head && getSystemSettings().head.languages) {
            return (
                <React.Fragment>
                {
                        getSystemSettings().head.languages.map((language, idx) => {
                            if(language.short === this.state.selectedLanguage) {
                                return(<span className="languageItem selected">{language.name}</span>)
                            }

                            return (
                                <div onClick={() => this.updateLocale(language.short)} className={"languageItem"} key={idx}>
                                {language.name} 
                                </div>
                            )
                        })
                } 
                </React.Fragment>
                
            )
        }

        return null;
    }

    updateLocale = (locale) => {
        this.setState({ 
            selectedLanguage: locale, displayModal: false },
            () => {
                const path = window.location.href.split("//")[1].split("/")[1];
                if (path.length === 2 && path.substring(0,1) !== 'v') {
                    if (path !== locale){
                        setLocale(path);
                        window.location.replace(
                            window.location.href.replace(`/${path}/`, `/${locale}/`)
                        );
                    }
                } else {
                    setLocale(locale);
                    window.location.reload();
                }
            }
        )
    }

    render(){
        const { state } = this;
        const { displayModal } = state;

        return(
            <div className="languageSelector">
                <Button onClick={() => this.setState({ displayModal: true })}>{LocaleAsString("header.info.language")}</Button>
                <Dialog
                    open={displayModal}
                    title={"Select your language"}
                    className="languageModal"
                    closeFn={() => this.setState({ displayModal: false })}
                    container={() => document.getElementsByClassName('main-application')[0]}
                    footerContent={
                        <React.Fragment>
                            <Button onClick={() => this.setState({ displayModal: false })} className="secondary">
                                <IntlMessage id="profile.itinerary.modal.close" />
                            </Button>
                        </React.Fragment>
                    }
                >
                    <div className="body">
                        { this.renderLanguagesList() }
                    </div>
                </Dialog>
            </div>
        )
    }
}